import { render, staticRenderFns } from "./SupportArticle.vue?vue&type=template&id=1f301737&"
import script from "./SupportArticle.vue?vue&type=script&lang=js&"
export * from "./SupportArticle.vue?vue&type=script&lang=js&"
import style0 from "./SupportArticle.vue?vue&type=style&index=0&id=1f301737&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports